module.exports = __webpack_public_path__ + "static/media/exercises-step10.52724259.png";